import { useCallback, useState } from 'react';

export default function useLoadingState() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingIds, setIsLoadingIds] = useState<string[]>([]);

  const updateIsLoading = useCallback(
    (isLoading: boolean) => setIsLoading(isLoading),
    [],
  );

  const updateIsLoadingIds = useCallback(
    (id: string, isAdding = true) =>
      setIsLoadingIds((prev) =>
        isAdding
          ? Array.from(new Set([...prev, id]))
          : prev.filter((i) => i !== id),
      ),
    [],
  );

  const getIsLoading = useCallback(
    (id: string) => isLoading || isLoadingIds.includes(id),
    [isLoading, isLoadingIds],
  );

  return {
    isLoading,
    isLoadingIds,
    updateIsLoading,
    updateIsLoadingIds,
    getIsLoading,
  };
}
